// extracted by mini-css-extract-plugin
export var header = "Header-module--header--AWpe5";
export var scrolled = "Header-module--scrolled--18WO-";